module.exports = __webpack_public_path__ + "fonts/Inter-SemiBold.dd8a55e.woff2";